import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=18fdc7d0&scoped=true&"
import script from "./ModalItem.vue?vue&type=script&lang=js&"
export * from "./ModalItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalItem.vue?vue&type=style&index=0&id=18fdc7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fdc7d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fdc7d0')) {
      api.createRecord('18fdc7d0', component.options)
    } else {
      api.reload('18fdc7d0', component.options)
    }
    module.hot.accept("./ModalItem.vue?vue&type=template&id=18fdc7d0&scoped=true&", function () {
      api.rerender('18fdc7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/general/ModalItem.vue"
export default component.exports